export var ICampaignFrequency;
(function (ICampaignFrequency) {
    ICampaignFrequency["UNIQUE"] = "Unique";
    ICampaignFrequency["EVERY_DAY"] = "Every day";
    ICampaignFrequency["EVERY_72H"] = "Every 72h";
    ICampaignFrequency["EVERY_WEEK"] = "Every week";
})(ICampaignFrequency || (ICampaignFrequency = {}));
